import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { AddressModule } from '../../../Address/address.module';
import { CorrespondenceNoSearchModule } from '../../../correspondence/correspondence-no-search.module';
import { DriverRecordSharedModule } from '../../../driverrecord/driver-record-shared.module';
import { DisbursementRequestModule } from '../../../finance/disbursement/request/disbursement-request.module';
import { DisbursementSummaryModule } from '../../../finance/disbursement/summary/disbursement-summary.module';
import { NoteModule } from '../../../note/note.module';
import { SharedComponentsModule } from '../../../shared/components/shared-components.module';
import { ValidationResultsModule } from '../../../shared/components/validation-results/validation-results.module';
import { SharedPipesModule } from '../../../shared/pipes/shared-pipes.module';
import { SharedValidatorsModule } from '../../../shared/validators/shared-validators.module';
import { ArtifactModalComponent } from '../../../transaction/artifact/artifact-modal.component';
import { ArtifactModule } from '../../../transaction/artifact/artifact.module';
import { VehicleInformationCoreModule } from '../../../vehicle/components/shared/vehicle/vehicle-information/vehicle-information-core.module';
import { CustomerAccountModule } from '../../account/customer-account.module';
import { HistoricalCustomerAddressModule } from '../../address/historical-customer-address.module';
import { CustomerAffiliationModule } from '../../affiliation/customer-affiliation.module';
import { HistoricalCustomerAffiliationModule } from '../../affiliation/historical-customer-affiliation.module';
import { CustomerAttributesModule } from '../../attributes/customer-attributes.module';
import { HistoricalCustomerAttributesModule } from '../../attributes/historical-customer-attributes.module';
import { CustomerCertificationModule } from '../../certification/customer-certification.module';
import { HistoricalCustomerCertificationModule } from '../../certification/historical-customer-certification.module';
import { CustomerCharacteristicModule } from '../../characteristic/customer-characteristic.module';
import { HistoricalCustomerCharacteristicModule } from '../../characteristic/historical-customer-characteristic.module';
import { CustomerContactModule } from '../../contacts/customer-contact.module';
import { HistoricalCustomerContactModule } from '../../contacts/historical-customer-contact.module';
import { CustomerFleetModule } from '../../fleet/customer-fleet.module';
import { CustomerIdentificationModule } from '../../identification/customer-identification.module';
import { HistoricalCustomerIdentificationModule } from '../../identification/historical-customer-identification.module';
import { CustomerImageModule } from '../../image/customer-image.module';
import { CustomerInsuranceModule } from '../../insurance/customer-insurance.module';
import { CustomerMedicalModule } from '../../medical/customer-medical.module';
import { HistoricalMedicalModule } from '../../medical/historical-customer-medical.module';
import { MVDNowViewModule } from '../../MVDNow/mvdnow-view.module';
import { CustomerNamesModule } from '../../name/customer-names.module';
import { CustomerPlacardModule } from '../../placard/customer-placard.module';
import { CustomerRepresentativeModule } from '../../representative/customer-representative.module';
import { HistoricalCustomerRepresentativeModule } from '../../representative/historical-customer-representative.module';
import { CustomerPipeModule } from '../../shared/pipes/customer-pipe.module';
import { CustomerVehicleModule } from '../../vehicle/customer-vehicle.module';
import { CustomerDetailService } from '../customer-detail.service';
import { IndividualCustomerDetailsModule } from './individual-customer-details.module';
import { IndividualCustomerPhotoModule } from './individual-customer-photo-modal.module';
import { IndividualCustomerComponent } from './individual-customer.component';
import { CommercialIntentTableModule } from '@max/medical-review/components/driver-commercial-intent/commercial-intent-table.module';
import { CustomerMrpCertificatesModule } from '@max/medical-review/components/customer-mrp-certificates/customer-mrp-certificates.module';
import { TsaSecurityThreatHistoryModule } from '@max/driver/tsa-security-threat/tsa-security-threat-history/tsa-security-threat-history.module';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        IndividualCustomerComponent
    ],
    providers: [
        CurrencyPipe,
        CustomerDetailService
    ],
    imports: [
        AddressModule,
        ArtifactModule,
        CalendarModule,
        CommonModule,
        CorrespondenceNoSearchModule,
        CustomerAccountModule,
        CustomerAffiliationModule,
        CustomerAttributesModule,
        CustomerCertificationModule,
        CustomerCharacteristicModule,
        CustomerContactModule,
        CustomerFleetModule,
        CustomerImageModule,
        CustomerIdentificationModule,
        CustomerMedicalModule,
        CustomerNamesModule,
        CustomerPipeModule,
        CustomerPlacardModule,
        CustomerInsuranceModule,
        CustomerRepresentativeModule,
        CustomerVehicleModule,
        DisbursementRequestModule,
        DisbursementSummaryModule,
        DriverRecordSharedModule,
        DropdownModule,
        HistoricalCustomerAddressModule,
        HistoricalCustomerAffiliationModule,
        HistoricalCustomerAttributesModule,
        HistoricalCustomerCharacteristicModule,
        HistoricalCustomerContactModule,
        HistoricalCustomerIdentificationModule,
        HistoricalCustomerRepresentativeModule,
        HistoricalMedicalModule,
        HistoricalCustomerCertificationModule,
        IndividualCustomerDetailsModule,
        IndividualCustomerPhotoModule,
        MVDNowViewModule,
        NoteModule,
        ReactiveFormsModule,
        SharedComponentsModule,
        SharedPipesModule,
        SharedValidatorsModule,
        TableModule,
        ValidationResultsModule,
        VehicleInformationCoreModule,
        CommercialIntentTableModule,
        CustomerMrpCertificatesModule,
        TsaSecurityThreatHistoryModule,
        RouterModule
    ],
    exports: [
        IndividualCustomerComponent
    ]
})
export class IndividualCustomerModule {
}
